<script>
import getLabel from 'foundation/js/getLabel';
import options from './StafetMailEditorOverlay.options'
import { isReadonly } from 'vue';
import AttachmentsViewer from 'components/AttachmentsViewer/AttachmentsViewer.vue';
export default options
</script>

<template>

  <div class="kb-overlay-styles__content-wrapper">

    <article class="kb-overlay-styles" :class="{ 'kb-overlay-styles--submitting': isSubmitting }">
      
      <div class="kb-overlay-styles__wrapper-for-scroll-bottom">

        <template v-if="!showReceipt">

          <section class="kb-send-mail-editor-overlay__hero">
            <div class="kb-send-mail-editor-overlay__hero__title-wrapper">
              <h2 class="kb-send-mail-editor-overlay__hero__title-wrapper__title">
                {{ heroTitle }}
              </h2>
            </div>

            <template v-if="heroText">
              <div class="kb-send-mail-editor-overlay__breaker">
                <svg viewBox="0 0 81 11" fill="none" xmlns="http://www.w3.org/2000/svg" ><path d="M2 .5h79v1H2v-1ZM1.5 2v9h-1V2h1Zm.5-.5a.5.5 0 0 0-.5.5h-1A1.5 1.5 0 0 1 2 .5v1Z" /></svg>
              </div>
              
              <div class="kb-send-mail-editor-overlay__description">
                <p class="kb-send-mail-editor-overlay__description-text">{{ heroText }}</p>
              </div>
            </template>
          </section>
  
          <div class="kb-overlay-styles__hero-curve">
            <svg role="presentation" viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z" />
            </svg>
          </div>
  
          <div class="kb-overlay-styles__form-content kb-stafet-donation-flow" v-if="!showResendConfirm">
  
            <section class="kb-stafet-step kb-optimizely-forms kb-stafet-donation-flow__step">
  
              <div class="kb-stafet-step__input-wrapper">
  
                <template v-if="allowSelectParticipants">
                    <div class="kb-overlay-styles__form-group">
                      <label class="Form__Element__Caption">
                        {{ getLabel('recipientsLabel') }}<span class="required-indicator" v-if="!isReadonly">*</span>
                      </label>
                      <template v-if="isReadonly">
                        <FormCheckbox
                          v-model="trueRef"
                          :label="recipientsJoinedLabels"
                          readOnly
                          />
                      </template>
                      <template v-else>
                        <FormCheckbox
                          fieldName="recipientsDeltagere"
                          v-model="recipientsDeltagere"
                          :label="getLabel('recipientsDeltagereLabel')"
                          :onChangeCallback="(e) => recipientsDeltagere = e.target.checked"
                        />
                        <FormCheckbox
                          fieldName="recipientsHoldkaptajner"
                          v-model="recipientsHoldkaptajner"
                          :label="getLabel('recipientsHoldkaptajnerLabel')"
                          :onChangeCallback="(e) => recipientsHoldkaptajner = e.target.checked"
                        />
                        <FormCheckbox
                          fieldName="recipientsFightere"
                          v-model="recipientsFightere"
                          :label="getLabel('recipientsFightereLabel')"
                          :onChangeCallback="(e) => recipientsFightere = e.target.checked"
                        />
                        <div aria-live="assertive">
                          <p class="kb-forms Form__Element__ValidationError" 
                            role="alert" 
                            v-if="displayError && !isRecipientsSelected">
                            {{ getLabel('recipientsErrorLabel') }}
                          </p>
                        </div>
                      </template>
                    </div>
                </template>
                
                <template v-if="allowSelectSeason">
                    <div class="kb-overlay-styles__form-group">
                        <label class="Form__Element__Caption">
                            {{ getLabel('seasonChoiceLabel') }}<span class="required-indicator" v-if="!isReadonly">*</span>
                        </label>
                        <FormRadioGroup
                        :radioOptions="seasonChoiceRadioOptions"
                        v-model="seasonChoice"
                        fieldName="seasonChoice"
                        :label="getLabel('seasonChoiceLabel')"
                        v-on:change="(e) => seasonChoice = e.target.value"
                        :isValidationError="displayError && !isSeasonSelected"
                        :errorMessageLabel="getLabel('seasonChoiceErrorLabel')"
                        :readOnly="isReadonly"
                        />
                    </div>
                </template>
  
                <FormInputTextField
                    :isRequired="!isReadonly"
                    v-model="subject"
                    fieldName="subject"
                    :label="getLabel('subjectLabel')"
                    :isValidationError="displayError && !subjectInputFilled"
                    :errorMessageLabel="getLabel('subjectErrorLabel')"
                    :readOnly="isReadonly"
                    maxlength="200"
                />
  
                <FormInputTextarea
                    :isRequired="!isReadonly"
                    v-model="body"
                    fieldName="body"
                    :modelValue="body"
                    :label="getLabel('bodyLabel')"
                    :isValidationError="displayError && !bodyInputFilled"
                    :errorMessageLabel="getLabel('bodyErrorLabel')"
                    :readOnly="isReadonly"
                    maxlength="10000"
                />
  
                <template v-if="!isReadonly && allowAttachments">
                  <AttachmentsEditor
                    @update:filesToAdd="$event => attachments = $event"
                    acceptedFileTypes=".doc, .docx, .ppt, .pptx, .xls, .xlsx, .pdf, .bmp, .png, .jpg, .jpeg, .svg, .gif, .mp4, .mov, .mp3"
                    :maxAttachments=3
                    :maxFileSizeBytes=25*1024*1024
                  />
                </template>
                <template v-else-if="isReadonly && attachments.length > 0">
                  <div>
                    <label class="Form__Element__Caption">
                      {{ getLabel('attachmentsLabel') }}
                    </label>
                    <AttachmentsViewer
                      :files="attachments"
                      showImagesAsFiles
                    />
                  </div>
                </template>
  
              </div>
  
              <template v-if="isLoadingNewRecipientsCount">
                <div>
                  <div class="kb-spinner-overlay">
                    <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"></div>
                  </div>
                </div>
              </template>
              <template v-if="numNewRecipientsCount !== null && numNewRecipientsCount > 0">
                <div class="kb-overlay-styles__form-group">
                  <p class="kb-forms">{{ resendInfoText }}</p>
                  <button class="kb-button kb-button--full-color-spot" :disabled="isResendDisabled" v-on:click="openResendConfirm">
                    {{ getLabel('resendCtaLabel') }}
                  </button>
                </div>
              </template>

              <template v-if="!isReadonly">
                  <nav class="kb-stafet-flow-actions">
                    <div class="kb-stafet-flow-actions__buttons-right-wrapper">
                      <button class="kb-button kb-button--full-color-spot kb-button--full-color-spot" v-on:click="submit">
                        {{ getLabel("submit") }}
                      </button>
                    </div>
                  </nav>
                  <div aria-live="assertive">
                    <p class="kb-forms Form__Element__ValidationError" 
                      role="alert" 
                      v-if="isSubmissionError">
                      {{ getLabel('submissionErrorLabel') }}
                    </p>
                  </div>
              </template>
  
            </section>
  
          </div>

          <div class="kb-overlay-styles__form-content kb-stafet-donation-flow" v-else>
            <div class="kb-send-mail-editor-overlay__body">
              <div class="kb-send-mail-editor-overlay__receipt">
                <button class="kb-button kb-button--full-color-spot" v-on:click="confirmResend">
                  {{ getLabel('resendConfirmTitle') }}
                </button>
                <button class="kb-button" v-on:click="cancelResend">
                  {{ getLabel('resendConfirmCancelLabel') }}
                </button>
              </div>
            </div>
          </div>
          
          <template v-if="isSubmitting">
            <div class="kb-spinner-overlay">
              <div class="kb-spinner-overlay__spinner kb-spinner-overlay__spinner--sticky"></div>
            </div>
          </template>

        </template>
        <template v-else>
          
          <article class="kb-send-mail-editor-overlay">
            <section class="kb-send-mail-editor-overlay__hero">
              <div class="kb-send-mail-editor-overlay__hero__title-wrapper">
                <div class="kb-send-mail-editor-overlay__hero__title-wrapper__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Zm0 .75C5.787.75.75 5.787.75 12S5.787 23.25 12 23.25 23.25 18.213 23.25 12 18.213.75 12 .75Zm4.924 7.015-5.625 9a.5.5 0 0 1-.785.08l-3.375-3.52.361-.346.361-.347 2.93 3.058 5.285-8.455.848.53Z"/>
                  </svg>
                </div>
                <h2 class="kb-send-mail-editor-overlay__hero__title-wrapper__title">
                  {{ getLabel('receiptTitle') }}
                </h2>
              </div>

              <div class="kb-send-mail-editor-overlay__breaker">
                <svg viewBox="0 0 81 11" fill="none" xmlns="http://www.w3.org/2000/svg" ><path d="M2 .5h79v1H2v-1ZM1.5 2v9h-1V2h1Zm.5-.5a.5.5 0 0 0-.5.5h-1A1.5 1.5 0 0 1 2 .5v1Z" /></svg>
              </div>
              
              <div class="kb-send-mail-editor-overlay__description">
                <p class="kb-send-mail-editor-overlay__description-text">{{ getLabel('receiptDescription') }}</p>
              </div>
            </section>

            <div class="kb-send-mail-editor-overlay__hero__curve">
              <svg viewBox="0 0 720 77" fill="none" xmlns="http://www.w3.org/2000/svg">kb-send-mail-editor-overlay__receipt
                <path d="M0 0V42.4078C238.547 71.2459 479.584 82.0555 720 74.8278V0H0Z" />
              </svg>
            </div>

            <div class="kb-send-mail-editor-overlay__body">
              <div class="kb-send-mail-editor-overlay__receipt">
                <button class="kb-button kb-button--full-color-spot" v-on:click="close">
                  {{ getLabel('receiptCloseButtonLabel') }}
                </button>
                <button class="kb-button" v-on:click="reset">
                  {{ getLabel('receiptResetButtonLabel') }}
                </button>
              </div>
            </div>
          </article>

        </template>

      </div>

    </article>

  </div>

</template>
